import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType;
};
